export { Button, type ButtonProps, type ButtonVariant, type ButtonSize } from './button';
export { Input, type InputProps } from './input';
export { Card, type CardProps } from './card';
// Legacy auth dialog (não confundir com primitivo shadcn Dialog em
// components/ui/dialog — renomeado pra LegacyAuthDialog).
export { Dialog as LegacyAuthDialog, type DialogProps as LegacyAuthDialogProps } from './dialog';
export { Badge, type BadgeProps, type BadgeTone } from './badge';
export { Squiggle, type SquiggleProps } from './squiggle';
export {
  PlaceholderState,
  type PlaceholderStateProps,
  type PlaceholderVariant,
} from './placeholder-state';

// autenticacao-onboarding (14 novos)
export { AuthLayout, type AuthLayoutProps } from './auth-layout';
export { BrandLogo, type BrandLogoProps } from './brand-logo';
export { BrandSquiggle, type BrandSquiggleProps } from './brand-squiggle';
export {
  OAuthProviderButton,
  type OAuthProviderButtonProps,
  type OAuthProvider,
  type OAuthVariant,
} from './oauth-provider-button';
export {
  ConsentCheckbox,
  type ConsentCheckboxProps,
  type ConsentType,
} from './components/facelift/consent-checkbox/ConsentCheckbox';
export { LegalDrawer, type LegalDrawerProps } from './legal-drawer';
export { OnboardingLayout, type OnboardingLayoutProps } from './onboarding-layout';
export {
  OnboardingStepHeader,
  type OnboardingStepHeaderProps,
} from './onboarding-step-header';
export { UserTypeCard, type UserTypeCardProps } from './user-type-card';
export { LocaleOption, type LocaleOptionProps } from './locale-option';
export { VibePill, type VibePillProps, type Vibe } from './vibe-pill';
export { WelcomeToast, type WelcomeToastProps } from './welcome-toast';
export { Banner, type BannerProps, type BannerVariant } from './banner';
export {
  PasswordStrengthMeter,
  computeScore,
  type PasswordStrengthMeterProps,
} from './password-strength-meter';
export {
  AuthCallbackLoading,
  type AuthCallbackLoadingProps,
} from './auth-callback-loading';

// landing-publica — componentes de marketing + mapa
export { ClubMap, type ClubMapProps, type ClubMapItem } from './club-map';

// ────────────────────────────────────────────────────────────────────────
// Facelift v1 — migracao-facelift-v1 (per ADR §D6)
// Primitivos shadcn em components/ui/* — re-exportados para consumers que
// preferem importar via barrel; preferência canônica é import direto
// '@brisa/ui/components/ui/<primitive>' per components.json aliases.
// ────────────────────────────────────────────────────────────────────────

export {
  Button as FaceliftButton,
  buttonVariants,
  type ButtonProps as FaceliftButtonProps,
} from './components/ui/button';
export {
  Input as FaceliftInput,
  type InputProps as FaceliftInputProps,
  type InputFaceliftSize,
} from './components/ui/input';
export { Label as FaceliftLabel, type LabelProps as FaceliftLabelProps } from './components/ui/label';
export {
  Badge as FaceliftBadge,
  badgeVariants,
  type BadgeProps as FaceliftBadgeProps,
} from './components/ui/badge';
export { Avatar, AvatarImage, AvatarFallback } from './components/ui/avatar';
export {
  Card as FaceliftCard,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
  cardVariants,
  type CardProps as FaceliftCardProps,
} from './components/ui/card';
export { Tabs, TabsList, TabsTrigger, TabsContent, type TabsVariant } from './components/ui/tabs';
export {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from './components/ui/accordion';
export {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuGroup,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuRadioGroup,
} from './components/ui/dropdown-menu';
export {
  Select,
  SelectGroup,
  SelectValue,
  SelectTrigger,
  SelectContent,
  SelectLabel,
  SelectItem,
  SelectSeparator,
  SelectScrollUpButton,
  SelectScrollDownButton,
} from './components/ui/select';
export { Switch } from './components/ui/switch';
export {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
  TooltipContent,
} from './components/ui/tooltip';
export {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
  useFormField,
} from './components/ui/form';

// Facelift composites
export {
  SquiggleLogo,
  type SquiggleLogoSize,
  type SquiggleLogoProps,
} from './components/facelift/brand/SquiggleLogo';
export {
  AvatarClube,
  type AvatarClubeSize,
  type AvatarClubeProps,
} from './components/facelift/avatar-clube/AvatarClube';
export {
  SectionTitle,
  type SectionTitleProps,
} from './components/facelift/section-title/SectionTitle';
export {
  FooterFacelift,
  type FooterFaceliftProps,
} from './components/facelift/footer/FooterFacelift';
export {
  HeaderFacelift,
  type HeaderFaceliftProps,
  type HeaderNavItem,
  type HeaderLanguageOption,
} from './components/facelift/header/HeaderFacelift';
export {
  BottomNavPill,
  type BottomNavPillItem,
  type BottomNavPillProps,
} from './components/facelift/bottom-nav-pill/BottomNavPill';
export {
  BottomNavPillRouter,
  type BottomNavPillRouterProps,
} from './components/facelift/bottom-nav-pill/BottomNavPillRouter';
export {
  IdentityCardBrisaV2,
  type IdentityCardMember,
  type IdentityCardStat,
  type IdentityCardBrisaV2Props,
} from './components/facelift/identity-card/IdentityCardBrisaV2';
export {
  EventCardHorizontal,
  type EventCardEvent,
  type EventCardHorizontalProps,
} from './components/facelift/event-card/EventCardHorizontal';
export {
  PassCardWithoutCta,
  type PassCatalogItem,
  type PassCardWithoutCtaProps,
} from './components/facelift/pass-card/PassCardWithoutCta';
export {
  CardPlanComplete,
  type CardPlanCompleteProps,
  type InfoRow as CardPlanInfoRow,
} from './components/facelift/pass-card/CardPlanComplete';
export {
  ClubCardFacelift,
  type ClubCardListItem,
  type ClubCardFaceliftProps,
} from './components/facelift/club-card/ClubCardFacelift';
export {
  ClubMapMarkerMiniCard,
  type ClubMapMarkerMiniCardClub,
  type ClubMapMarkerMiniCardProps,
} from './components/facelift/club-map-marker/ClubMapMarkerMiniCard';
export {
  PinMap,
  type PinMapProps,
  type PinMapState,
  type PinMapSize,
  type PinMapIntegrationStatus,
} from './components/facelift/pin-map/PinMap';
export {
  ClubMapFacelift,
  type ClubMapFaceliftProps,
  type ClubMapFaceliftItem,
  type ClubMapFaceliftHandle,
} from './components/facelift/club-map/ClubMapFacelift';
export {
  VerifiedBadge,
  type VerifiedBadgeProps,
} from './components/facelift/verified-badge/VerifiedBadge';

// admin-basico-login (W3.2) — componentes presentacionais Fase 1 Storybook FIRST
export {
  LoginBrandPanel,
  type LoginBrandPanelProps,
} from './components/facelift/login-brand-panel/LoginBrandPanel';
// EmptyShortcutsState (facelift) removido em W3.2 v1.2 — substituído por
// EmptyState genérico em admin/empty-state/. Ver ADR §Design System Split.
export {
  EmptyState,
  type EmptyStateProps,
} from './components/admin/empty-state/EmptyState';
// AdminHeader (facelift) removido em W3.2 v1.2 — substituído por
// DashboardShell em admin/dashboard-shell/. Ver ADR §Design System Split.
export {
  DashboardShell,
  type DashboardShellProps,
  type DashboardShellEnv,
  type DashboardShellLocale,
  type DashboardShellNavItem,
} from './components/admin/dashboard-shell/DashboardShell';

// ---------------------------------------------------------------------------
// Primitivos shadcn — admin neutro (W3.2 v1.2) — 13 novos via shadcn CLI/registry.
// Consumidos sob scope `[data-theme="admin"]` em rotas /admin/*. Tokens
// `--background`/`--foreground`/etc. são sobrescritos pelo admin-v1/tokens.css.
// ---------------------------------------------------------------------------
export {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
} from './components/ui/alert-dialog';
export {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from './components/ui/breadcrumb';
export { Checkbox } from './components/ui/checkbox';
export {
  Command,
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
  CommandShortcut,
} from './components/ui/command';
export {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from './components/ui/dialog';
export {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from './components/ui/popover';
export { ScrollArea, ScrollBar } from './components/ui/scroll-area';
export { Separator } from './components/ui/separator';
export {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetOverlay,
  SheetPortal,
  SheetTitle,
  SheetTrigger,
} from './components/ui/sheet';
export {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupAction,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarInput,
  SidebarInset,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuBadge,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSkeleton,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  SidebarProvider,
  SidebarRail,
  SidebarSeparator,
  SidebarTrigger,
  useSidebar,
} from './components/ui/sidebar';
export { Skeleton } from './components/ui/skeleton';
export { Toaster } from './components/ui/sonner';
export {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from './components/ui/table';

// Hook usado pelo Sidebar + composições admin
export { useIsMobile } from './hooks/use-mobile';

// Helper
export { cn } from './lib/utils';
